// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"6e1d4205","202":"5ea7d788","373":"f76e046c","456":"5be66adc","811":"3f1ec15e","817":"1eb38464"}[chunkId] + ".chunk.js";
};